export function getConfigMap(userConfig: any[]): Record<string, any> {
  const map: Record<string, any> = {}
  for (const obj of userConfig) {
    map[obj.config_key] = obj.value
  }
  return map
}
